import { useSelector } from 'react-redux';
import { AdminAdvertisingLayout } from '../../../../common/components';
import UpdateAdvertisingCampaign from '../../../common/advertising-campaign/UpdateAdvertisingCampaign';
import { getUser } from '../../../../common/store';

const AdminUpdateAdvertisingCampaign = () => {
    const user = useSelector(getUser);
    const orgId = user?.org?.id;

    return (
        <AdminAdvertisingLayout title="Alterar campanha de publicidade">
            <UpdateAdvertisingCampaign orgId={orgId} />
        </AdminAdvertisingLayout>
    );
};

export default AdminUpdateAdvertisingCampaign;
